module.exports = "<div class=\"bg-light lter b-b wrapper-md\">\n  <h1 class=\"m-n font-thin h3\">Tags</h1>\n  <small class=\"text-muted\">Quandoo Operation Center</small>\n</div>\n<div class=\"wrapper-md\">\n  <div class=\"panel panel-default\">\n    <div class=\"panel-heading\">\n      Tag List\n    </div>\n    <app-tag-list-table></app-tag-list-table>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/tags/tags.component.html
// module id = 1182
// module chunks = 0